import { render } from "./FieldBorrowerOtherIncome.vue?vue&type=template&id=c99ba084"
import script from "./FieldBorrowerOtherIncome.vue?vue&type=script&lang=js"
export * from "./FieldBorrowerOtherIncome.vue?vue&type=script&lang=js"

import "./FieldBorrowerOtherIncome.vue?vue&type=style&index=0&id=c99ba084&lang=css"

import exportComponent from "/home/alexey/mv/mortgageware/vendor/sudoux/cms/Sudoux/Cms/FormBundle/Resources/views/Vuejs/Apps/formbuilder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import Ripple from 'quasar/src/directives/Ripple.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QAvatar,QItemLabel,QIcon,QForm,QBtn,QField,QDialog,QCard,QCardSection,QCardActions});qInstall(script, 'directives', {Ripple,ClosePopup});
